<h1 mat-dialog-title>Attention</h1>
<div mat-dialog-content>We are unable to forward this message.Please contact Sales.</div>
<div mat-dialog-actions>
    <button mat-button id="button" mat-dialog-close style="background-color: #7E84F2 !important;">Close</button>
</div>